class GiftWrap extends HTMLElement {
  constructor() {
    super();
  }

  addGiftWrapToCart() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer.loading) {
      this.cart.setLoading();
      const giftWrapConfig = fetchConfig("javascript");
      giftWrapConfig.headers["x-requested-with"] = "XMLHttpRequest";
      delete giftWrapConfig.headers["Content-Type"];
      const giftWrapForm = new FormData();

      giftWrapForm.append("items[0][id]", this.giftWrapVariantId);
      giftWrapForm.append("items[0][quantity]", 1);

      giftWrapForm.append("note", this.giftMessage);

      giftWrapForm.append(
        "sections",
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      giftWrapForm.append("sections_url", window.location.pathname);
      giftWrapConfig.body = giftWrapForm;

      this.cart.setActiveElement(document.activeElement);

      fetch(routes.cart_add_url, giftWrapConfig)
        .then((response) => response.json())
        .then((response) => {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "vbb-gift-wrap",
          });

          this.cart.renderContents(response);
        })
        .catch((e) => console.error(e))
        .finally(() => {
          if (this.cart.classList.contains("is-empty")) {
            this.cart.classList.remove("is-empty");
          }

          this.cart.setNotLoading();
        });
    }
  }

  setGiftMessage(event) {
    const message = event.target.value;

    if (message == null || message === "") {
      this.giftMessage = null;
    } else {
      this.giftMessage = `GIFT_MSG: ${message} END_MSG`;
    }
  }

  trackCharacterCount() {
    const textarea = this.querySelector("textarea");
    const charCount = this.querySelector("#charCount");
    const maxLength = textarea.maxLength;

    this.querySelector("textarea").addEventListener("input", () => {
      const currentLength = textarea.value.length;
      charCount.textContent = `${currentLength}/${maxLength}`;
    });
  }

  connectedCallback() {
    this.cart = document.querySelector("cart-drawer");
    this.giftWrapVariantId = this.dataset.giftWrapVariantId;
    this.giftMessage = null;
    if (this.querySelector("textarea")) {
      this.querySelector("textarea").addEventListener("change", (event) =>
        this.setGiftMessage(event).bind(this)
      );
      this.trackCharacterCount();
    }

    this.querySelector("button").addEventListener("click", (event) =>
      this.addGiftWrapToCart().bind(this)
    );
  }
}

customElements.define("vbb-gift-wrap", GiftWrap);
